"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CalendarIcon = function CalendarIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 4.00008V3.33341C13.3333 2.96522 13.6318 2.66675 14 2.66675C14.3682 2.66675 14.6667 2.96522 14.6667 3.33341V4.00008H16.6667C17.4029 4.00008 18 4.59723 18 5.33342V16.0001C18 16.7363 17.4029 17.3334 16.6667 17.3334H3.33333C2.59714 17.3334 2 16.7363 2 16.0001V8.7599V5.33342C2 4.59723 2.59714 4.00008 3.33333 4.00008H5.33333V3.33341C5.33333 2.96522 5.63181 2.66675 5.99999 2.66675C6.36819 2.66675 6.66666 2.96522 6.66666 3.33341V4.00008H13.3333ZM3.6521 9.58266V15.7453H16.3484V9.58266H3.6521ZM16.3484 7.93715H3.6521V5.58822H5.33333V6.00008C5.33333 6.36827 5.63181 6.66675 5.99999 6.66675C6.36819 6.66675 6.66666 6.36827 6.66666 6.00008V5.58822H13.3333V6.00008C13.3333 6.36827 13.6318 6.66675 14 6.66675C14.3682 6.66675 14.6667 6.36827 14.6667 6.00008V5.58822H16.3484V7.93715Z",
    fill: color
  }));
};

var _default = CalendarIcon;
exports.default = _default;